<template>
    <v-dialog v-model="dialognewuser" transition="none" max-width="340" content-class="right-modal" scrollable>
      <v-card class="pa-0" style="border-radius:12px; overflow-y:auto; max-height:calc(100vh - 64px); display:flex; flex-direction:column;">
        <div style="background: #00BFA5; width: 100%; text-align: center; padding: 16px 0; flex-shrink: 0; position: relative;">
          <h4 class="text-white" style="margin:0; font-weight:700;">SETUP USER KPI</h4>
        </div>
        <v-card-text class="pa-4">
          <v-form>
            <v-text-field
                label="Position Name *"
                v-model="localSelectedNode.position_name"
                dense
                outlined
              />
            <v-textarea
              label="Notes"
              v-model="localSelectedNode.notes"
              dense
              outlined
              rows="5"
            />
            
            <!-- <v-select
                  label="Assign User"
                  :items="users"
                  item-text="text"
                  item-value="value"
                  v-model="localSelectedNode.assignUser"
                  dense
                  outlined
                  clearable
                /> -->
            <v-select
              label="Report To *"
              :items="reportToList"
              item-text="text"
              item-value="value"
              v-model="localSelectedNode.reportTo"
              dense
              
              outlined
              clearable
            />
            <div class="text-caption grey--text mt-1">
              * Assign user bisa dilakukan setelah pembuatan position.
            </div>
            <div class="mt-4 d-flex justify-space-between">
              <v-btn color="error" dark @click="dialognewuser = false">Cancel</v-btn>
              <v-btn color="primary" dark @click="submitNew">Submit</v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
<script>
export default {
	props: {
		value: Boolean,
		selectedNode: Object,
		users: Array,
		reportToList: Array,
	},
	emits: ["input", "submitted", "snackbar"],
	data() {
		return {
			localUsers: [],
			position_name: "",
			localReportToList: [],
			localSelectedNode: { ...this.selectedNode },
		};
	},
	computed: {
		dialognewuser: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	watch: {
		selectedNode: {
			immediate: true,
			deep: true,
			handler(newVal) {
				this.localSelectedNode = { ...newVal };
			},
		},
	},
	methods: {
		async submitNew() {
			this.$store.dispatch("setOverlay", true);
			const formData = new FormData();
			formData.append("position_name", this.localSelectedNode.position_name);
			formData.append("position_description", this.localSelectedNode.notes);
			formData.append("chart_parent_id", this.localSelectedNode.reportTo || "");
			formData.append("user_id", this.localSelectedNode.assignUser || "");
			formData.append("user_parent_id", "");
			for (const [k, v] of formData.entries()) {
				console.log(`${k}:`, v);
			}
			try {
				await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/charts`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "multipart/form-data",
						},
					}
				);
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "User KPI successfully created",
				});
				this.$emit("submitted");
				this.dialognewuser = false;
				setTimeout(() => {
					this.$store.dispatch("setOverlay", false);
					window.location.reload();
				}, 1000);
			} catch (err) {
				this.$store.dispatch("setOverlay", false);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Failed to create chart",
				});
			}
		},
	},
};
</script>